<template>
  <div class="year" :year="year.year">
    <h3>{{ year.year }}</h3>
    <div class="grid">
      <div v-for="n in 12">
        <MonthYearItem
          style="margin-left: 3px; margin-right: 3px;"
          @click="setYearMonth(n)"
          :month="year.months[n-1]"
          :daysOfWeek="daysOfWeek"
          :days="getDays(year.months[n-1])" />
      </div>
    </div>
  </div>
</template>

<script>
import MonthYearItem from "@/components/calendarScroller/monthYearItem.vue";

export default {
  props:["year","months","daysOfWeek"],
  emits:["setMonth"],
  components: {
    MonthYearItem,
  },
  methods: {
    setYearMonth(n){
      this.$emit('setMonth' ,{year:this.year.year,month:n-1})
    },
    getDays(month) {
      const days = [];
      const today = new Date();
      const firstDay = new Date(`${month.month}/01/${month.year}`).getDay();
      const startingDay = firstDay === 0 ? 7 : firstDay; // convert Sunday (0) to 7
      for (let i = 1; i < startingDay; i++) {
        days.push({ key: i, text: "", classes: "day empty" });
      }
      for (let i = 1; i <= month.days; i++) {
        const date = new Date(`${month.month}/${i}/${month.year}`);
        const isToday = date.getFullYear() === today.getFullYear()
          && date.getMonth() === today.getMonth()
          && date.getDate() === today.getDate();
        days.push({ key: i, text: i, classes: `day${isToday ? ' today' : ''}` });
      }
      return days;
    },
  },
};
</script>

<style scoped>
.grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(4, 1fr);
  gap: 10px;
}

h3{
  font-size: 23px;
  margin: 10px 0;
  font-family: "Montserrat";
}

.year{
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
}
</style>